import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-gray-900 text-white">
        <h1 className="text-8xl md:text-9xl font-bold text-red-500">404</h1>
        <h2 className="text-2xl md:text-4xl font-semibold mt-6">This Page is Broken</h2>
        <p className="mt-4 text-lg md:text-xl text-gray-400">
          Don't worry, we can fix it! (Just not this one.)
        </p>
        <Link to="/" className="mt-8 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors">
          Return to Homepage
        </Link>
      </div>
    );
  }

export { NotFound };